<div class="alg-workflow-dialog">
  <ng-container *ngIf="formLoading; else formLoaded"><div class="loading-indicator"><mat-spinner diameter="48"></mat-spinner></div></ng-container>
  <ng-template #formLoaded>
    <h2 mat-dialog-title class="alg-workflow-dialog__header"><mat-icon>task_alt</mat-icon>{{taskInstance.name}}</h2>
    <mat-dialog-content class="alg-workflow-dialog__content">
      <div class="alg-workflow-dialog__meta"><div><span class="alg-workflow-dialog__label">Démarrée le</span>{{taskInstance.startedAt | date:'dd/MM/yyyy à HH:mm'}}</div><div><span class="alg-workflow-dialog__label">Description</span>{{taskInstance.description || 'Aucune description'}}</div><div><span class="alg-workflow-dialog__label">Statut</span>{{taskInstance.state | traduction}}</div></div>
      <app-form type="editTask" [formProperties]="formProperties" [form]="form" [items]="items"></app-form>
    </mat-dialog-content>
  </ng-template>
</div>
